<div class="min-h-screen bg-section flex text-body-text">
  <!-- Sidebar -->
  <aside 
    class="bg-heading text-section transition-all duration-300 fixed h-full z-50 flex flex-col border-r border-white/10"
    [class.w-64]="isSidebarOpen"
    [class.w-20]="!isSidebarOpen && !isMobile"
    [class.-translate-x-full]="!isSidebarOpen && isMobile"
    [class.translate-x-0]="isSidebarOpen && isMobile"
  >
    <!-- Logo Section -->
    <div class="p-6 border-b border-white/10 shrink-0">
      <div class="flex items-center gap-3">
        <img src="FINAL.png" alt="Aarvya Logo" class="h-10 w-auto object-contain" *ngIf="isSidebarOpen">
        <img src="FINAL.png" alt="Aarvya Logo" class="h-8 w-auto object-contain" *ngIf="!isSidebarOpen">
      </div>
    </div>

    <!-- Navigation -->
    <nav class="flex-1 overflow-y-auto p-4 space-y-2 mt-4">
      <a routerLink="/admin/dashboard" routerLinkActive="sidebar-link-active" [routerLinkActiveOptions]="{exact: true}" class="sidebar-link sidebar-link-inactive group">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 group-hover:scale-110 transition-transform">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
        </svg>
        <span *ngIf="isSidebarOpen" class="animate-fade-in">Dashboard</span>
      </a>

      <a routerLink="/admin/products" routerLinkActive="sidebar-link-active" class="sidebar-link sidebar-link-inactive group">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 group-hover:scale-110 transition-transform">
          <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
        </svg>
        <span *ngIf="isSidebarOpen" class="animate-fade-in">Products</span>
      </a>


      <a routerLink="/admin/orders" routerLinkActive="sidebar-link-active" class="sidebar-link sidebar-link-inactive group">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 group-hover:scale-110 transition-transform">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
        </svg>
        <span *ngIf="isSidebarOpen" class="animate-fade-in">Orders</span>
      </a>

      <a routerLink="/admin/reviews" routerLinkActive="sidebar-link-active" class="sidebar-link sidebar-link-inactive group">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 group-hover:scale-110 transition-transform">
          <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.562 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
        </svg>
        <span *ngIf="isSidebarOpen" class="animate-fade-in">Reviews</span>
      </a>

      <a routerLink="/admin/customers" routerLinkActive="sidebar-link-active" class="sidebar-link sidebar-link-inactive group">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 group-hover:scale-110 transition-transform">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-3.833-6.242 4.125 4.125 0 00-3.831 6.242m-5.174-8.243a3.125 3.125 0 116.25 0 3.125 3.125 0 01-6.25 0M9 15.551a3.124 3.124 0 10-6.248 0 3.124 3.124 0 006.248 0zM3.5 19.128a9.38 9.38 0 012.625.372 9.337 9.337 0 014.121-.952 4.125 4.125 0 00-3.833-6.242 4.125 4.125 0 01-3.831 6.242m5.174-8.243a3.125 3.125 0 116.25 0 3.125 3.125 0 01-6.25 0z" />
        </svg>
        <span *ngIf="isSidebarOpen" class="animate-fade-in">Customers</span>
      </a>

      <a routerLink="/admin/referral-sources" routerLinkActive="sidebar-link-active" class="sidebar-link sidebar-link-inactive group">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 group-hover:scale-110 transition-transform">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
        </svg>
        <span *ngIf="isSidebarOpen" class="animate-fade-in">Referral Sources</span>
      </a>
    </nav>

    <!-- User Section -->
    <div class="p-4 border-t border-white/10 shrink-0">
      <div class="flex items-center gap-3 p-2 rounded-sm hover:bg-white/5 transition-colors group cursor-pointer" (click)="logout()">
        <div class="w-8 h-8 rounded-full bg-btn/20 flex items-center justify-center border border-btn/30">
          <img src="FINAL.png" alt="Aarvya Logo" class="w-6 h-6 object-contain">
        </div>
        <div *ngIf="isSidebarOpen" class="flex-1 min-w-0">
          <p class="text-sm font-serif truncate">Admin User</p>
          <p class="text-[10px] text-section/50 uppercase tracking-wider">Logout</p>
        </div>
        <svg *ngIf="isSidebarOpen" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-section/30 group-hover:text-white transition-colors">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
        </svg>
      </div>
    </div>
  </aside>

  <!-- Mobile Overlay -->
  <div 
    *ngIf="isSidebarOpen && isMobile" 
    class="fixed inset-0 bg-heading/40 backdrop-blur-sm z-40 lg:hidden"
    (click)="toggleSidebar()"
  ></div>

  <!-- Main Content Area -->
  <main 
    class="flex-1 transition-all duration-300 min-h-screen flex flex-col w-full"
    [style.marginLeft]="isMobile ? '0' : (isSidebarOpen ? '16rem' : '5rem')"
  >
    <!-- Top Header -->
    <header class="h-20 bg-section/90 border-b border-[#E5DDD5] flex items-center justify-between px-4 sm:px-8 sticky top-0 z-40 backdrop-blur-md">
      <div class="flex items-center gap-4">
        <button 
          (click)="toggleSidebar()" 
          class="p-2 text-heading hover:bg-section rounded transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
          </svg>
        </button>
        <h2 class="text-lg font-serif text-heading tracking-wide">Control Panel</h2>
        <a routerLink="/home" class="ml-4 px-4 py-1.5 border border-heading text-heading font-serif uppercase text-[10px] tracking-widest hover:bg-heading hover:text-white transition-all duration-300 rounded-sm">
           Home Store
        </a>
      </div>

      <div class="flex items-center gap-6">
        <!-- Notifications -->
        <button class="relative p-2 text-muted hover:text-heading transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
          </svg>
          <span class="absolute top-2 right-2 w-2 h-2 bg-btn rounded-full border-2 border-white"></span>
        </button>

        <div class="w-px h-8 border-r border-[#E5DDD5]"></div>

        <!-- Date Display -->
        <div class="text-right hidden sm:block">
          <p class="text-[10px] text-muted uppercase tracking-widest font-serif">Today</p>
          <p class="text-sm text-heading font-serif">{{ today | date:'fullDate' }}</p>
        </div>
      </div>
    </header>

    <!-- Content Outlet -->
    <div class="p-4 sm:p-8 flex-1">
      <router-outlet></router-outlet>
    </div>

    <!-- Footer -->
    <footer class="p-4 sm:p-8 pt-0 text-center">
      <div class="w-full h-px bg-gradient-to-r from-transparent via-[#E5DDD5] to-transparent mb-4 opacity-50"></div>
      <p class="text-xs text-muted font-serif italic">Aarvya Admin Dashboard &copy; 2026</p>
    </footer>
  </main>
</div>
